import { createSlice } from '@reduxjs/toolkit'

export const presenceSlice = createSlice({
    name: 'presence',
    initialState: {
        presence: {}
    },
    reducers: {
        set: (state, { payload }) => {
            state.presence = ({ ...state.presence, ...payload })
        }
    }
})

export default presenceSlice.reducer

export const { set } = presenceSlice.actions

export const selectPresence = state => state.presence
